import React, { useEffect, useState } from 'react';
import { Card, Container, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { formSubmissionToast } from 'helpers/utils';
import { isEmpty } from 'lodash';
import DynamicFormV2 from 'screens/common/dynamicFormV2';
import PropTypes from 'prop-types';
import { getTenantFromToken } from 'utils/routeUtils';

function DynamicFormPage(formProps) {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const tenant = getTenantFromToken();

  const [data, setData] = useState({});

  // Fetch Form Data
  const fetchData = async () => {
    try {
      const response = isEditMode
        ? await formProps.fetchEditFormApi(id)
        : await formProps.fetchFormApi();
      setData(response.data.results);
    } catch (error) {
      console.error('Error fetching form data:', error);
      toast.error(
        'Oops! Your session timed out due to inactivity. Please log in again to continue'
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  // Submit Handler
  const handleFormSubmit = async formData => {
    try {
      // Dynamic empty array field check based on backend metadata
      const requiredArrayFields = Object.entries(data?.fields || {}).filter(
        ([_, fieldMeta]) =>
          fieldMeta?.error_message &&
          Array.isArray(formData?.[fieldMeta.id || _]) &&
          formData?.[fieldMeta.id || _]?.length === 0
      );

      if (requiredArrayFields.length > 0) {
        const [fieldKey, fieldMeta] = requiredArrayFields[0];
        toast.error(fieldMeta?.error_message);
        return;
      }

      let response;
      if (isEditMode) {
        response = await formProps.updateApi(id, formData);
        formSubmissionToast(response, toast, formProps.title, true);
      } else {
        response = await formProps.createApi(formData);
        console.log(response, 'response');
        formSubmissionToast(response, toast, formProps.title);
      }
      navigate(`/${tenant}${formProps.reportPath}`);
    } catch (error) {
      formSubmissionToast(error, toast, formProps.title);
    }
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate(`/${tenant}${formProps.reportPath}`)}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>
        {isEditMode ? `Edit ${formProps.title}` : `Create ${formProps.title}`}
      </span>
    </div>
  );

  return (
    <Container>
      <Row>
        <Card className="mb-3">
          <Card.Header className="mb-3 px-0 p-sm-3">
            <FalconCardHeader
              title={header}
              className="ps-lg-4"
              titleTag="h5"
              titleClass="mb-0"
              light
            />
          </Card.Header>
          <Card.Body className="mb-3 p-0 p-sm-3">
            {!isEmpty(data) && (
              <DynamicFormV2
                data={data}
                header={true}
                onSubmit={handleFormSubmit}
                mode={isEditMode ? 'edit' : 'create'}
              />
            )}
          </Card.Body>
        </Card>
      </Row>
    </Container>
  );
}

DynamicFormPage.defaultProps = { formProps: {} };

DynamicFormPage.propTypes = {
  formProps: PropTypes.shape({
    fetchEditFormApi: PropTypes.func,
    fetchFormApi: PropTypes.func,
    updateApi: PropTypes.func,
    createApi: PropTypes.func,
    reportPath: PropTypes.string,
    title: PropTypes.string
  })
};

export default DynamicFormPage;
